$(document).ready(function() {
	setupTracking(); 
	// **** IMPORTANT: Disable setupLogin(); when testing locally and for sharing with C2
	setupLogin(); 
	$('.popup-link').on('click', function(e) {
		e.preventDefault();
		openPopup('https://www.schwab.com/public/file/P-11331435/', '682', '520', '');
		return false;
	})
}); 
//  end doc.ready

function setupTracking(selectors) {
  //Can pass in selectors as string or array
  if(typeof selectors === 'string') {
	if(!selectors.match(/,/g)) {
        selectors = $.makeArray(selectors);
	} else {
        selectors = selectors.split(',');
	}
	//If nothing is supplied, use the default data attributes
  } else if(selectors === undefined) {
	selectors = ['[data-dctracking]', '[data-tracking]', '[data-smtracking]'];
  }

  //Loop through selectors and set up tracking
  $.each(selectors, function(index, selector) {
	$(selector+':not([data-tracking-registered])').on('click', function(e) {
        var $self = $(this);
        
	  if($self.data('dctracking') !== undefined) {
		var trackingType = $self.data('dctype') || waDcType,
		  trackingAccount = $self.data('dcacct') || waDcSrc,
		  trackingCat = $self.data('dctracking') || waDcCat;
		try {
		  DcOnClickTracking(trackingType, trackingCat);
		} catch (error) {
		  console.log( "Error Message:", error.message );
		}
	  }

	  if($self.is("[data-smtracking]")) {
		try {
		  mmConversionTag($self.data("smtracking"), $self[0]);
		} catch(err) {
		  console.log("Sizmek error:", err);
		}
	  }

	  if ($self.data('tracking') !== undefined) {
		var trackingId = $self.data('tracking'),
		  trackingType = $self.data('type') || 'o',
		  share = $self.data('share') || false;

		if($self.is("[data-furl]")) {
		  if($self.hasClass("furl-open")) {
			trackingId += "-close";
		  } else {
			trackingId += "-open";
		  }
		}

		try {
		  if (share) {
			scatShareLinkTrack(trackingType, trackingId);
		  } else {
			scatCustomLinkTrack(trackingType, trackingId);
		  }
		} catch (error) {
		  console.log( "Error Message:", error.message );
		}
	  }

	  if($self.is("a:not([href^=#],.popup-link,.media-expand-toggle, [target='_blank'])")) {
		e.preventDefault();
		setTimeout(function() { window.location.href = $self.prop("href"); }, 250);
	  }
	});

	//Attribute to show that this element has already been registered for tracking
	$(selector).attr('data-tracking-registered', '');
  });
}

// get query var or parameter from url
function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return (false);
}

function setupLogin() {
	var redirectID, target, iframeSource;
	target = getQueryVariable('nextstep');
	if(target.length > 0 && target != "default") {
		switch(target) {
			case "contribution":
				redirectID = 202;
				break;
			case "beneficiary":
				redirectID = 206;
				break;
			case "advice":
				redirectID = 204;
				break;
			case "review":
				redirectID = 300;
				break;
			case "learning":
				redirectID = 225;
				break;
			default:
				break;
		}
		if(redirectID > 0) {
			iframeSource = "https://lms.schwab.com/Login?clientId=rpsp&state=redirectid=" + redirectID + "-pid=&styleid=lms-styles-enroll5";
		}
		else {
			iframeSource = "https://lms.schwab.com/Login?clientId=rpsp&state=na&styleid=lms-styles-enroll5";
		}
	}
	else {
		iframeSource = "https://lms.schwab.com/Login?clientId=rpsp&state=na&styleid=lms-styles-enroll5";
	}
	// console.log(iframeSource);
	var loginFrame = $('.login-box iframe');
	loginFrame.prop("src", iframeSource);
}

function openPopup(url, width, height, name, left, top, properties) {
	if (isValidUrl(url)) window.open(url, ((name && name != "") ? name : "popup"), ((width && width != "") ? "width=" + width + "," : "") + ((height && height != "") ? "height=" + height + "," : "") + ((properties && properties != "") ? properties : "status=yes,toolbar=no,menubar=no,location=no,scrollbars=yes,resizable=yes") + ((left && left != "") ? ",left=" + left : "") + ((top && top != "") ? ",top=" + top : "")) }

function isValidUrl(url) { return !(typeof(url) == "undefined" || url == null || url == "" || url.toLowerCase() == "none" || url.toLowerCase() == "null" || url == "-1") }
